var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "horizon",
          tabItems: _vm.tabItems,
          inlineLabel: true,
          dense: true,
          height: _vm.tabHeight,
          tabOptions: _vm.tabOptions,
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
          "update:tabOptions": function ($event) {
            _vm.tabOptions = $event
          },
          "update:tab-options": function ($event) {
            _vm.tabOptions = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: {
                    param: _vm.popupParam,
                    psmFlag: _vm.psmFlag,
                    ghsFlag: _vm.ghsFlag,
                  },
                  on: {
                    "update:param": function ($event) {
                      _vm.popupParam = $event
                    },
                    "update:psmFlag": function ($event) {
                      _vm.psmFlag = $event
                    },
                    "update:psm-flag": function ($event) {
                      _vm.psmFlag = $event
                    },
                    "update:ghsFlag": function ($event) {
                      _vm.ghsFlag = $event
                    },
                    "update:ghs-flag": function ($event) {
                      _vm.ghsFlag = $event
                    },
                    insertEquipInfo: _vm.updateMode,
                    updateChemInfo: _vm.updateData,
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }